import discordHero from '../../../media/software/discord/railway_interface.png';
import discord2 from '../../../media/software/discord/ryan_selfie.jpg';

const discordData = {
    name: "Discord Trading Bot",
    category: "Scripting",
    tagline: "Automated trading signal filter and management bot for GRX Trades",
    duration: "Fall 2025",
    heroImage: discordHero,

    description: "I developed a Discord bot for [[GRX Trades::https://github.com/Madmaxme/GRX_Trades_Filter]] to filter and manage high-volume trading signals before they reach members. The bot ingests trades from a third-party source and applies configurable threshold filters. Administrators can adjust parameters and view statistics directly within Discord. I built and deployed the project on Railway on a short timeline.",

    techStack: [
        "Node.js",
        "Discord.js",
        "Railway",
        "Webhooks",
        "REST APIs"
    ],

    gallery: [
        { type: 'image', src: discordHero, alt: 'Discord bot management interface hosted on Railway' },
        { type: 'image', src: discord2, alt: 'Collaborative development session with project stakeholder' }
    ],
    links: {
        github: "https://github.com/Madmaxme/GRX_Trades_Filter",
    },
};

export default discordData;